import { render, staticRenderFns } from "./MenuUserItem.vue?vue&type=template&id=04a4651d&scoped=true"
import script from "./MenuUserItem.vue?vue&type=script&lang=js"
export * from "./MenuUserItem.vue?vue&type=script&lang=js"
import style0 from "./MenuUserItem.vue?vue&type=style&index=0&id=04a4651d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a4651d",
  null
  
)

export default component.exports